import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class JobService extends RLBaseService {
    static $inject = ["$resource"];
    constructor(private $resource: ng.resource.IResourceService) {
        super($resource);
    }

    deleteJob(workOrderID: string) {
        var data = {
            entityID: workOrderID
        };
        return this.toRLService<void>("/api/job/deleteworkorder").post(data).$promise;
    }

    getContactsForEntity(entityID: string) {
        var data = {
            entityID: entityID
        };
        return this.toRLService<Models.IContactParty>("/api/contact/GetContacts", {}).query(data).$promise;
    }

    getJobInventory(jobID: string) {
        var data = {
            jobID: jobID
        };
        return this.toRLService<Models.IEntityRelationshipPair>("/api/job/getjobinventory", {}).query(data).$promise;
    }

    addJobInventory(jobID: string, invetoryIDs: number[]) {
        var data = {
            jobID: jobID,
            invetoryIDs: invetoryIDs
        };
        return this.toRLService<string>("/api/job/addjobinventory").postArray(data).$promise;
    }

    removeJobInventory(jobID: string, relRecID: number) {
        var data = {
            jobID: jobID,
            relRecID: relRecID
        };
        return this.toRLService<boolean>("/api/job/removejobinventory").post(data).$promise;
    }

    deleteJobAttachment(workOrderID: number, attachmentID: number) {
        var data = {
            workOrderID: workOrderID,
            attachmentID: attachmentID
        };
        return this.toRLService<void>("/api/job/deleteworkorderattachment").post(data).$promise;
    }
}